import api, { unwrap } from './client';

// Cascade « du temps payé à la capacité inutilisée » — 3 colonnes (N-1 / N réel / N extrapolé).
export const getCapacityOverview = (tenantId, year) =>
  unwrap(api.get(`/capacity-overview/${tenantId}/${year}`));

// Audit capacité — chaîne contrat→TR par personne + synthèse par pool (réel vs standard).
export const getCapacityAudit = (tenantId, year) =>
  unwrap(api.get(`/capacity-audit/${tenantId}/${year}`));
